module.exports = "<md-dialog style=width:400px> <md-dialog-content> <change-password-form on-change=\"\" change-password-data=$ctrl.changePasswordData change-password-form=$ctrl.changePasswordForm></change-password-form> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>CHANGE_PASSWORD</span> </md-button> </md-dialog-actions> </md-dialog>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/userManagement/details/change-password-dialog.html
 ** module id = 285
 ** module chunks = 0
 **/